import React, { useContext } from 'react'
import { LiabilitiesContext } from '../../context'
import { Button } from '@components/Button'
import { Modal, ModalHeader, ModalSubHeader, ModalContent, ModalFooter } from '@components/Modal'

export const Destroy = () => {
  const { state, actions } = useContext(LiabilitiesContext)
  const { liability, loading } = state
  const { confirmDelete, back } = actions

  const trackingText = 'Liability: Delete confirm'
  return (
    <Modal open onClose={back} small className="asset-confirmation-modal">
      <ModalHeader>Are you sure you want to delete the liability?</ModalHeader>
      <ModalSubHeader>{liability.name}</ModalSubHeader>
      <ModalContent>
        <p>This will permanently remove the liability from this scenario.</p>
      </ModalContent>
      <ModalFooter>
        <Button secondary onClick={back}>NOT RIGHT NOW</Button>
        <Button disabled={loading} primary trackAs={trackingText} onClick={confirmDelete}>
          {loading ? 'Deleting liability...' : "YES I'M SURE"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
